<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Órdenes por finalizar</h2></v-toolbar-title></pre>
        </v-toolbar>

        <v-row>
            <v-col cols="12" md="4">
                <date-select
                    label="Fecha de inicio"
                    v-model="fecha_inicio"
                ></date-select>
            </v-col>
            <v-col cols="12" md="4">
                <date-select
                    label="Fecha de fin"
                    v-model="fecha_fin"
                ></date-select>
            </v-col>
        </v-row>

        <v-data-table
            dense
            :headers="headers"
            :items="Ordenes"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
            <template v-slot:item.planificacion_one.fecha="{ item }">
                <template v-if="item.planificacion_one != null">
                    <template v-if="item.planificacion_one.fecha != null">
                        {{ item.planificacion_one.fecha | format_date }}
                    </template>
                </template>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
export default {
    data() {
        return {
            fecha_inicio: null,
            fecha_fin: null,
            /// orden, fecha, pedte de cobro, cliente, número, comercial
            headers: [
                { text: "Nº Obra", value: "nro_orden", sortable: false },
                {
                    text: "Fecha de finalización",
                    value: "planificacion_one.fecha",
                    sortable: false,
                },
                { text: "Pdte de cobro", value: "pendiente", sortable: false },
                {
                    text: "Cliente",
                    value: "cliente.nombre_comercial",
                    sortable: false,
                },
                {
                    text: "Número",
                    value: "cliente.telefono",
                    sortable: false,
                },
                {
                    text: "Comercial",
                    value: "nombre_comercial",
                    sortable: false,
                },
            ],

            Ordenes: [],
        };
    },
    created() {
        const today = new Date();

        // Get tomorrow's date
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);

        // Format dates to 'YYYY-MM-DD' (optional)
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");
            return `${year}-${month}-${day}`;
        };
        this.fecha_inicio = formatDate(today);
        this.fecha_fin = formatDate(tomorrow);
        this.getOrdenes();
    },
    methods: {
        getOrdenes() {
            if (this.fecha_inicio == null || this.fecha_fin == null) return;
            axios
                .get(
                    `api/get-ultimas-ordenes?startDate=${this.fecha_inicio}&endDate=${this.fecha_fin}`
                )
                .then(
                    (res) => {
                        this.Ordenes = res.data;
                    },
                    (err) => {
                        this.$custom_error("Error consultando las obras");
                    }
                );
        },
    },
    computed: {
        rol: function () {
            let rol = localStorage.getItem("role");
            console.log(rol);
            return rol;
        },
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
    watch: {
        fecha_inicio: {
            deep: true,
            handler: function (val) {
                this.getOrdenes();
            },
        },
        fecha_fin: {
            deep: true,
            handler: function (val) {
                this.getOrdenes();
            },
        },
    },
};
</script>
